import { useQuery } from '@apollo/client/react'
import Spinner from '~/components/Spinner'
import { GQL_SURVEY_QUESTIONS } from '~/gql/surveys/surveys'
import SurveyQuestionsEditor from './SurveyQuestionsEditor'

/**
 * Le questionnaire de fin de parcours de l'organisation (#320), proposé aux
 * apprenants avant leur attestation. Les réponses déjà données gardent les
 * libellés lus : reformuler une question ne réécrit pas les avis passés.
 */
function SurveyQuestionsPage() {
  const { data } = useQuery(GQL_SURVEY_QUESTIONS, { fetchPolicy: 'network-only' })

  if (!data) return <div className="flex justify-center p-10"><Spinner className="size-6" /></div>
  return <SurveyQuestionsEditor initial={data.surveyQuestions} />
}

export default SurveyQuestionsPage
